function CheckBoxFormatter({ value = false }) {
    return <input readOnly type="checkbox" checked={value}></input>;
}

export default CheckBoxFormatter;
